import React, {useEffect, useRef} from "react";
import {connect} from "react-redux";
import SqftFeaturesPopup from "./sqftFeaturesPopup";
import {changeSqftFeaturesPopup} from "../../../actions/sqftFunctions";
import {handleOpenConflictPopups} from "../../../misc/conflictPopups";

const SqftFeaturesPopupWrapper = (props) => {
  const { sqftFeaturesPopup, changeSqftFeaturesPopup } = props;
  const isOpened = sqftFeaturesPopup.opened;
  const wrapperRef = useRef(null);

  useEffect(() => {
    const closePopup = () => {
      changeSqftFeaturesPopup({ opened: false, sqftPassedData: null });
      handleOpenConflictPopups();
    };

    const isClickInsidePopup = (event) => {
      if (!wrapperRef.current) {
        return false;
      }

      if (wrapperRef.current.contains(event.target)) {
        return true;
      }

      const touch = event.touches && event.touches[0] ||
        event.changedTouches && event.changedTouches[0];
      const pointer = touch || event;
      const popupBounds = wrapperRef.current.getBoundingClientRect();
      return pointer.clientX >= popupBounds.left &&
        pointer.clientX <= popupBounds.right &&
        pointer.clientY >= popupBounds.top &&
        pointer.clientY <= popupBounds.bottom;
    };

    const handleClickOutside = (event) => {
      if (!isClickInsidePopup(event)) {
        closePopup();
      }
    };

    if (isOpened) {
      document.addEventListener("mousedown", handleClickOutside, true);
      document.addEventListener("touchstart", handleClickOutside, true);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside, true);
      document.removeEventListener("touchstart", handleClickOutside, true);
    };
  }, [isOpened, changeSqftFeaturesPopup]);

  return (
    <div className={"ui-popup sqft-popup sqft-popupv2 " + (isOpened ? "sqft-popupv2--opened" : "")}
         ref={wrapperRef}>
      <SqftFeaturesPopup/>
    </div>
  );
};

const mapStateToProps = (store) => {
  const {sqftFeaturesPopup, sqftFromFeature} = store.sqftState;
  return {
    sqftFeaturesPopup,
    sqftFromFeature,
  };
};

const mapDispatchToProps = {
  changeSqftFeaturesPopup
};

export default connect(mapStateToProps, mapDispatchToProps)(SqftFeaturesPopupWrapper);
